import React from 'react';
import { Link } from 'react-router-dom';
import { Search, Share2, Target, ArrowUpRight, ArrowRight } from 'lucide-react';
import useReveal from '../hooks/useReveal';

const ADS = [
  {
    id: 'google-ads',
    icon: 'Search',
    title: 'Google Ads',
    price: 'From £495 + VAT / mo',
    description:
      'Search, Performance Max and Shopping campaigns that capture demand the exact moment people are looking for what you sell.',
  },
  {
    id: 'combined-ads',
    icon: 'Target',
    title: 'Google + Meta',
    price: 'From £795 + VAT / mo',
    description:
      'The full funnel — capture existing demand on Google and create new demand on Meta, planned and managed as one joined-up engine.',
    featured: true,
    badge: 'Recommended',
  },
  {
    id: 'meta-ads',
    icon: 'Share2',
    title: 'Meta Ads',
    price: 'From £495 + VAT / mo',
    description:
      'Facebook and Instagram campaigns that build demand, retarget warm audiences and turn scrolling into sales.',
  },
];

const ICONS = { Search, Share2, Target };

function AdCard({ ad, index }) {
  const ref = useReveal();
  const Icon = ICONS[ad.icon];
  return (
    <article
      ref={ref}
      className={`ai-card reveal ${ad.featured ? 'ai-card-featured' : ''}`}
      style={{ transitionDelay: `${(index % 3) * 90}ms` }}
      data-testid={`home-ad-card-${ad.id}`}
    >
      {ad.badge && <span className="ads-badge">{ad.badge}</span>}
      <div className="ai-card-icon"><Icon size={24} /></div>
      <h3 className="ai-card-title">{ad.title}</h3>
      <span className="ads-price">{ad.price}</span>
      <p className="ai-card-desc">{ad.description}</p>
    </article>
  );
}

export default function PaidAds() {
  const headRef = useReveal();
  const ctaRef = useReveal();
  const goContact = () => document.querySelector('#contact')?.scrollIntoView({ behavior: 'smooth' });

  return (
    <section className="section ads-section" id="ads" aria-label="Google and Meta Ads Management" data-testid="ads-section">
      <div className="section-inner">
        <div className="section-head reveal" ref={headRef}>
          <span className="section-eyebrow">// PAID MEDIA // GOOGLE &amp; META ADS</span>
          <h2 className="section-title">
            ADS THAT PUT YOU IN FRONT OF <span className="text-pink">BUYERS</span>
          </h2>
          <p className="section-sub">
            Managed Google and Meta advertising — set up, optimised and reported by real people,
            supercharged by AI. Launch faster, spend smarter, and see exactly what your budget is doing.
          </p>
        </div>

        <div className="ai-grid ads-grid">
          {ADS.map((ad, i) => (
            <AdCard key={ad.id} ad={ad} index={i} />
          ))}
        </div>

        <div className="ai-cta reveal" ref={ctaRef}>
          <p className="ai-cta-text">
            Transparent monthly management with no long tie-ins — and your ad account always stays yours.
          </p>
          <div className="ads-cta-btns">
            <Link
              to={{ pathname: '/website-design-pricing', hash: '#paid-media' }}
              className="boost-btn boost-btn-primary boost-btn-lg"
              data-testid="home-ads-pricing-link"
            >
              See paid media pricing <ArrowRight size={18} />
            </Link>
            <button className="boost-btn boost-btn-ghost boost-btn-lg" onClick={goContact} data-testid="home-ads-contact">
              Start a project <ArrowUpRight size={18} />
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
